import format from 'date-fns/format';

export function formatDate(timestamp) {
  if (timestamp) {
    return format(timestamp, 'd MMM, y');
  }

  return '';
}
